import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// 1. IMPORT YOUR LOCAL IMAGES HERE
import gal1 from "./Images/gal1.jpg";
import gal2 from "./Images/gal2.png";
import gal3 from "./Images/gal3.jpg";
import gal4 from "./Images/gal4.png";
import gal5 from "./Images/gal5.png";
import gal6 from "./Images/gal6.png";
import gal7 from "./Images/gal7.png";
import gal8 from "./Images/gal8.png";
// import gal9 from "./Images/gal9.png";

// 2. TEMPORARY PLACEHOLDERS (Replace these with your imported images)


// 3. SET UP YOUR GALLERY DATA
const GALLERY_DATA = [
  { id: 2, src: gal2 },
 
  { id: 3, src: gal3 },
  { id: 4, src: gal4 },
  { id: 5, src: gal5 },
{ id: 1, src: gal1 },
  { id: 6, src: gal6 },
    { id: 7, src: gal7 },
    { id: 8, src: gal8 },
];

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="min-h-screen bg-[#f8f9fc] py-16">
      
      {/* ── HEADER ── */}
      <div className="text-center max-w-3xl mx-auto px-4 mb-14">
        <span className="inline-block text-xs font-extrabold tracking-[0.2em] uppercase bg-red-50 border border-red-200 text-[#d11210] px-4 py-1.5 rounded-full mb-4">
          ★ Our Memories
        </span>
        <h1 className="text-4xl sm:text-5xl font-black text-gray-900 mb-4">
          Institute <span className="text-[#d11210]">Gallery</span>
        </h1>
        <p className="text-gray-500 text-lg">
          Take a glimpse into the vibrant life, events, and facilities at Anabel Institute.
        </p>
      </div>

      {/* ── IMAGE GRID ── */}
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 lg:gap-6">
          {GALLERY_DATA.map((img) => (
            <div
              key={img.id}
              className="relative cursor-pointer overflow-hidden rounded-xl bg-gray-200 shadow-sm hover:shadow-xl transition-shadow duration-300 w-full h-64 sm:h-72 lg:h-80"
              onClick={() => setSelectedImage(img.src)}
            >
              <img
                src={img.src}
                alt="Gallery item"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500 ease-in-out"
              />
            </div>
          ))}
        </div>
      </div>

      {/* ── LIGHTBOX (MODAL) ── */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm p-4 sm:p-8"
            onClick={() => setSelectedImage(null)}
          >
            {/* Close Button */}
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-6 right-6 sm:top-10 sm:right-10 w-12 h-12 bg-[#d11210] hover:bg-white hover:text-[#d11210] text-white rounded-full flex items-center justify-center transition-colors shadow-lg z-50"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Full Image */}
            <motion.div
              initial={{ scale: 0.95 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.95 }}
              className="relative max-w-6xl w-full flex items-center justify-center"
              onClick={(e) => e.stopPropagation()} // Prevent clicking image from closing modal
            >
              <img
                src={selectedImage}
                alt="Full screen view"
                className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl border border-gray-800"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
}